import { render, staticRenderFns } from "./CadDadosBasicos.vue?vue&type=template&id=29ccc7f4&"
import script from "./CadDadosBasicos.vue?vue&type=script&lang=js&"
export * from "./CadDadosBasicos.vue?vue&type=script&lang=js&"
import style0 from "./CadDadosBasicos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CadDadosBasicos.vue"
export default component.exports